module.exports = __webpack_public_path__ + "img/Doner Kebab Icon - charcoal.9c5cad96.svg";